var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.944,
    height: 17.434,
    viewBox: "0 0 14.944 17.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.5 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2,28.727H17.958V26.859a3.117,3.117,0,0,0-3.113-3.113H11.109A3.117,3.117,0,0,0,8,26.859v1.868H6.75V26.859A4.364,4.364,0,0,1,11.109,22.5h3.736A4.364,4.364,0,0,1,19.2,26.859Z",
    transform: "translate(-1.005 -9.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.123,6.75a.623.623,0,0,0-.623.623v5.6H5.745v-5.6A.623.623,0,0,0,5.123,6.75Z",
    transform: "translate(0 -2.009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,2.25V3.5H7.613V7.854a4.359,4.359,0,0,0,8.717,0V3.5h3.113V2.25ZM8.859,3.5h6.227V5.363H8.859Zm3.113,7.472A3.113,3.113,0,0,1,8.859,7.854V6.609h6.227V7.854A3.113,3.113,0,0,1,11.972,10.967Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.12244a767bad3f99d48600f394bcbc18.svg";
export { ForwardRef as ReactComponent };